import { BiCodeAlt } from "react-icons/bi";
import ServicesCard from "./ServicesCard";
import { LuBrainCircuit, LuDatabase, LuCloud } from "react-icons/lu";

const MyServices = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <ServicesCard
        icons={<BiCodeAlt />}
        title="Full Stack Development"
        subTitle="Building scalable full-stack applications using React.js, Next.js, Vue.js, Node.js, and Flask with modern best practices and design patterns."
      />
      <ServicesCard
        icons={<LuCloud />}
        title="Cloud & DevOps"
        subTitle="Designing serverless applications with AWS Lambda, implementing CI/CD pipelines, and managing cloud infrastructure for optimal performance."
      />
      <ServicesCard
        icons={<LuBrainCircuit />}
        title="ML/AI Solutions"
        subTitle="Developing and deploying machine learning models into production environments, integrating AI capabilities into scalable applications."
      />
      <ServicesCard
        icons={<LuDatabase />}
        title="Data Engineering"
        subTitle="Building data pipelines, performing data analysis and mining, creating insights through Power BI dashboards and EDA."
      />
    </div>
  );
};

export default MyServices;
